<af-full-table
    class="w-100 h-100"
    [dataSource]="dataSource"
    [totalElements]="totalElements"
    (tableUpdateListener)="loadJobs($event)"
    [showSearchBar]="false"
    [showImport]="false"
    [showExport]="false"
    totalElementsTranslationKey="i18n_af_labelTotalElementsJobs"
    emptyStateIconName="ic_empty_state_data_no_created"
    emptyStateTitleTranslationKey="i18n_af_emptyStateTitleJobs"/>
